import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import $ from 'jquery';
import * as Cookie from 'js-cookie';
import URI from 'urijs';
import { originalHash } from 'Environment';
import { AuthExtensions } from './authExtensions';
import { ParsedRequirementNode } from './requirementNodesProcessor';

const RETURN_URL = '_rt';
const HASH_FRAGMENT = '_hf';
const STATE_CONTEXT = '_cx';
const CREDENTIAL_ID = '_id';
const POST_RETURN_URL = '_ps';
const CSRF_TOKEN = '_cs';
const POSTBACK_URL = '_pb';

export function registerWebviewCredentialHandler() {
	AuthExtensions.addCustomCredentialHandler({
		getCredentialTypeName() {
			return 'webview';
		},

		getDataToAutoPost(
			_$form: JQuery,
			requirements: ParsedRequirementNode,
			workspaceConfiguration: WorkspaceConfiguration
		) {
			const webViewData = requirements.credential.webview;
			let startURL = webViewData.startUrl;
			const split = startURL.split('?');
			startURL = split.shift();
			const queryStr = split.length === 0 ? '' : split.join('?');
			const parameters = new URI('?' + queryStr).query(true) as Record<
				string,
				string | boolean
			>;

			const postData = webViewData.postData;
			let postToStartUrl = false;

			if (postData) {
				postToStartUrl = true;
				const postDataParameters = new URI('?' + postData).query(true);
				$.extend(parameters, postDataParameters);
			}
			const id = requirements.credential.id;
			parameters[CREDENTIAL_ID] = id;

			const stateContext = webViewData.stateContext;
			parameters[STATE_CONTEXT] = stateContext;

			const relativeReturnUrl = workspaceConfiguration.authManager.webviewReturnURL;
			const returnUrl = new URI(relativeReturnUrl).absoluteTo(location.href).toString();
			parameters[RETURN_URL] = returnUrl;

			const csrf = Cookie.get('CsrfToken');
			parameters[CSRF_TOKEN] = csrf;

			const resumeFormsUrl = workspaceConfiguration.authManager.webviewResumeURL;
			if (!resumeFormsUrl) {
				// No resume forms URL is defined in the configuration, so form data will be submitted to
				// the form postback URL. Send it to the webview start URL so that it can be retrieved later.
				parameters[POSTBACK_URL] = webViewData.postbackUrl;
			}

			if (originalHash !== '') {
				parameters[HASH_FRAGMENT] = originalHash;
			}

			parameters[POST_RETURN_URL] = true;

			redirectToStartUrl(startURL, parameters, postToStartUrl);
		},
	});
}

function redirectToStartUrl(startUrl: string, parameters: object, usePost: boolean) {
	if (!usePost) {
		const parameterString = $.param(parameters, true);
		window.location.assign(startUrl + '?' + parameterString);
	} else {
		redirectWithPost(startUrl, parameters);
	}
}

function redirectWithPost(url: string, parameters: object) {
	const $form = $('<form/>');
	$form.attr('method', 'post');
	$form.attr('action', url);

	$.each(parameters, function (key, value) {
		const $field = $('<input/>');
		$field.attr('type', 'hidden');
		$field.attr('name', key);
		$field.attr('value', value);

		$form.append($field);
	});

	$(document.body).append($form);
	$form.submit();
}
